'use client';
import { signIn } from 'next-auth/react';
import { useState } from 'react';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    const res = await signIn('credentials', { username, password, redirect: false });
    if (res?.ok) {
      const next = new URLSearchParams(window.location.search).get('next') || '/dashboard';
      window.location.href = next;
    } else {
      setError('Login fehlgeschlagen');
    }
  }

  return (
    <div className="max-w-md mx-auto bg-zinc-800/70 rounded-2xl shadow p-6">
      <h1 className="text-2xl font-semibold mb-4 text-white text-center">Anmelden</h1>
      <form onSubmit={onSubmit} className="space-y-4">
        <input className="w-full border rounded p-2" placeholder="Username" value={username} onChange={e=>setUsername(e.target.value)} />
        <input className="w-full border rounded p-2" placeholder="Passwort" type="password" value={password} onChange={e=>setPassword(e.target.value)} />
        {error && <p className="text-red-600 text-sm">{error}</p>}
        <button className="w-full bg-black text-white rounded-lg py-2">Login</button>
      </form>
    </div>
  );
}
